import { CreateTenantRate } from "@models";
import { rateService } from "@services";
import { makeAutoObservable } from "mobx";

export default class RateStore {
  rateLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  createTenantRate = async (request: CreateTenantRate) => {
    this.setLoading(true);
    try {
      await rateService.createTenantRate(request);
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  };

  setLoading = (loading: boolean) => {
    this.rateLoading = loading;
  };
}
